import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import {
  PRO_MONTHLY_PRICE,
  PRO_OFFER_SUMMARY,
} from '../../constants/proPricing';
import {
  Disclaimer,
  Eyebrow,
  FeatureDesc,
  FeatureIcon,
  FeatureLabel,
  FeatureList,
  FeatureRow,
  IntroText,
  OfferLine,
  PlanCard,
  PlanName,
  PriceAmount,
  PriceNote,
  PricePeriod,
  PriceRow,
  PricingPanel,
  PrimaryCta,
  SecondaryCta,
  Title,
} from './Pricing.styled';

const FEATURES = [
  { Icon: PersonRoundedIcon, label: 'Business profile', desc: 'Stand out with a polished local presence' },
  { Icon: StorefrontRoundedIcon, label: 'Storefront website', desc: 'Your own branded page, no coding needed' },
  { Icon: ListAltRoundedIcon, label: 'Service catalog', desc: 'Showcase everything you offer in one place' },
  { Icon: CalendarMonthRoundedIcon, label: 'Dashboard & calendar', desc: 'Manage requests and stay organized' },
  { Icon: InsightsRoundedIcon, label: 'Basic analytics', desc: 'See how customers find and engage with you' },
];

/** Plan card for service businesses (About page). Prices come from constants/proPricing. */
export const Pricing = () => (
  <PricingPanel id="pricing" aria-labelledby="pricing-title">
    <div>
      <Eyebrow>For pros</Eyebrow>
      <Title id="pricing-title">Get found. Get booked.</Title>
      <IntroText>
        Smart tools and AI-powered visibility for Northern Kentucky service pros, so local
        homeowners find you when they search for your trade.
      </IntroText>
    </div>

    <PlanCard>
      <PlanName>NKY Connect Pro</PlanName>
      <PriceRow>
        <PriceAmount>{PRO_MONTHLY_PRICE}</PriceAmount>
        <PricePeriod>/ month</PricePeriod>
      </PriceRow>
      <PriceNote>Cancel anytime.</PriceNote>

      <FeatureList>
        {FEATURES.map(({ Icon, label, desc }) => (
          <FeatureRow key={label}>
            <FeatureIcon aria-hidden>
              <Icon />
            </FeatureIcon>
            <span>
              <FeatureLabel>{label}</FeatureLabel>
              <FeatureDesc>{desc}</FeatureDesc>
            </span>
          </FeatureRow>
        ))}
      </FeatureList>

      <OfferLine>
        <CardGiftcardRoundedIcon aria-hidden />
        {PRO_OFFER_SUMMARY}
      </OfferLine>
      <PrimaryCta component={RouterLink} to="/provider-signup">
        Get started
      </PrimaryCta>
      <SecondaryCta component={RouterLink} to="/join-existing-business" variant="outlined">
        Join an existing business team
      </SecondaryCta>
      <Disclaimer>No credit card required.</Disclaimer>
    </PlanCard>
  </PricingPanel>
);

export default Pricing;
